export const Version = { git_commit:"6ac079bd064d61590e56ea64756a244680e04c96.b2" };